import React from 'react';
import AsyncPage from './async';
import DefaultErrorLayout from '../../components/layout/DefaultErrorLayout';

export default [
  <DefaultErrorLayout component={AsyncPage}/>,
];
